<wiz-vgroup height="100%" width="100%">
  <wiz-label #measLbl></wiz-label>
  <wiz-list
    class=""
    #list
    width="100%"
    height="100%"
    [wizDataProvider]="listDS"
    [wizItemRenderer]="listWidgetItemRenderer"
  ></wiz-list>
</wiz-vgroup>
